import {Component} from 'react';
import styled from "styled-components";
import axios from "axios";
import storage from "../utils/storage";

const Title = styled.div``;
const Description = styled.div``;

const ErrorScreen = styled(({ className }) => {
    return (
        <div className={className}>
            <Title>Something went wrong.</Title>
            <Description>Please try that again.</Description>
            <button type="button" onClick={() => location.replace("/")}>Go home</button>
        </div>
    );
})`
  font-family: 'Inter';
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #edeff0d9;
  ${Title} {
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 8px;
  }
  ${Description} {
    font-size: 15px;
    color: #4d5156;
    padding-top: 2px;
    padding-bottom: 24px;
  }
  button {
    cursor: pointer;
    font-family: inherit;
    font-style: inherit;
    font-size: 15px;
    font-weight: 600;
    padding: 10px 24px;
    border: 0;
    border-radius: 4px;
    background-color: black;
    color: white;
  }
`;

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
        this.caught = false;
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, errorInfo) {
        if (this.caught) {
            return;
        }
        this.caught = true;
        try {
            const key = storage.getItem('api_key');
            const secret = storage.getItem('api_secret');
            if (!key || !secret) {
                // return;
            }
            const data = new FormData();
            data.set('app', `Win-Mobile ${import.meta.env.VITE_APP_VERSION}`);
            data.set('location', location.toString());
            data.set('error', error.name || '');
            data.set('message', error.message || '');
            data.set('stack', error.stack || '');
            data.set('componentStack', errorInfo?.componentStack || '');
            data.set('userAgent', navigator.userAgent);
            data.set('vendor', navigator.vendor);
            data.set('platform', navigator.platform);
            if (import.meta.env.DEV) {
                // eslint-disable-next-line no-console
                console.info(`report not sent`, Array.from(data.entries()));
                return;
            }
            axios.post(
                `${import.meta.env.VITE_API_BASE_URL}/api/v2/oops`,
                data, {
                    timeout: 5000,
                    headers: {
                        'X-Api-Key': key,
                        'X-Api-Secret': secret,
                    }
                }
            );
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        } finally {
            // eslint-disable-next-line no-console
            console.log(error, errorInfo);
        }
    }

    render() {
        const { error } = this.state;
        if (error) {
            return <ErrorScreen error={error}/>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
